import { render } from "./BtnDownloadFile.vue?vue&type=template&id=fb85da18&scoped=true"
import script from "./BtnDownloadFile.vue?vue&type=script&lang=js"
export * from "./BtnDownloadFile.vue?vue&type=script&lang=js"

import "./BtnDownloadFile.vue?vue&type=style&index=0&id=fb85da18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb85da18"]])

export default __exports__